export default __webpack_public_path__ + "static/media/C8.d83bd365.png";